import React from 'react';

const getNameAvatarUrl = profile => {
  // console.log(`https://ui-avatars.com/api/?name=${profile?.firstName}+${profile?.lastName}`)
  return `https://ui-avatars.com/api/?name=${profile?.firstName}+${profile?.lastName}`;
};

export default getNameAvatarUrl;
